<template>
    <div>
        <base-crud
                crudName="Mensagens do SAC"
                newText="Nova Mensagem"
                :table="contactUsTable"
                :columns="columns"
                :options="options"
                :endPoint='endPoint'
                :enableAdd="false"
                :enableEdit="false"
                :enableDelete="true"
                :enableView="true"
        >
        </base-crud>
    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'

    export default {
        data: function () {
            return {
                contactUsTable: 'contactUsTable',
                users: [],
                pages: [],
                url: '',
                columns: ['id', 'name', 'phone', 'email', 'message', 'actions'],
                tableData: [],
                options: {
                    sortable: ['id','name', 'phone', 'email', 'message'],
                    pagination: {chunk: 10, dropdown:false, nav: 'scroll' },
                    perPage: 10,
                    perPageValues: [10,25,50,100],
                    headings: {
                        'name': 'Nome',
                        'phone': 'Telefone',
                        'email': 'E-mail',
                        'message': 'Mensagem',
                        'actions': 'Ações'
                    }
                },
                endPoint: 'contactUs/'
            }
        },
        components: {
            BaseCrud
        }
    }
</script>

<style scoped>
    .VuePagination {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/ContactUs/Crud.vue